import { render, staticRenderFns } from "./zyara.vue?vue&type=template&id=39944848&"
import script from "./zyara.vue?vue&type=script&lang=js&"
export * from "./zyara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports